module.exports = __webpack_public_path__ + "static/media/Icon-TextToSpeech-Audio.6187eaff.png";